export const selfServeTrialPeriodDays = 7;

export function selfServeTrialLabel(): string {
  return `${String(selfServeTrialPeriodDays)}-day free trial`;
}

export const ingestCreditPackFootnote =
  "Extra ingest packs are optional AI credits for auto Markdown conversion and importing. They are not required for the core knowledge base.";

export function creditPackPurchaseLabel(amountUsd: number): string {
  return `Buy 100 credits · $${String(amountUsd)}*`;
}

export const resumeSubscriptionLabel = "Resume subscription";

export const subscriptionPausedMemberCopy =
  "This workspace's subscription is paused. Ask an owner to resume billing to restore access.";
